import React from "react";
import { useEffect, useState } from 'react';
import { Card, Table, OverlayTrigger, Tooltip, Button, Col, Row, Container, Form, Modal, Spinner } from "react-bootstrap";
import ReusableModal from "../Shared/ReusableModal"
import { capitalizeFirstLetter, CharacterCount } from '../Shared/Helpers';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from "lodash";
import SweetAlert from "react-bootstrap-sweetalert";

//function FormRow({ index }) {
//    return (
//        <Row>
//            <Col md={12}>
//                <p >Employment {index + 1}</p>
//            </Col>

//            <Col md={3}>
//                <h5 className="form-label">Employer Name:</h5>
//                <Form.Group>
//                    <Form.Control className="form-control custom-input" type="text" />
//                </Form.Group>
//            </Col>

//            <Col md={2}>
//                <h5 className="form-label">Length of Service:</h5>
//                <Form.Group>
//                    <Form.Control className="form-control custom-input" type="text" />
//                </Form.Group>
//            </Col>

//            <Col md={4}>
//                <h5 className="form-label">Position held and description of duties:</h5>
//                <Form.Group>
//                    <Form.Control className="form-control custom-input" type="text" />
//                </Form.Group>
//            </Col>

//            <Col md={2}>
//                <h5 className="form-label">Reason for leaving:</h5>
//                <Form.Group>
//                    <Form.Control className="form-control custom-input" type="text" />
//                </Form.Group>
//            </Col>
//            {index !== 0 && (
//                <Col md={1}>
//                    <h5 className="form-label"></h5>
//                    <Button variant="danger" onClick={() => handleRemoveRow(index)}>
//                        <i className="fas fa-trash" aria-hidden="true"></i>
//                    </Button>
//                </Col>
//            )}
//        </Row>
//    );
//}

//const handleAddRow = () => {
//    const newFormRows = [...formRows];
//    newFormRows.push(<FormRow key={newFormRows.length} />);
//    setFormRows(newFormRows);
////};

//{/*<div className="card-container">*/ }
//{/*    <Card className="form-card">*/ }
//{/*        <Card.Body>*/ }
//{/*            {formRows.map((row, index) => (*/ }
//{/*                <FormRow key={index} index={index} />*/ }
//{/*            ))}*/ }

//{/*            <Button variant="primary" onClick={handleAddRow}>*/ }
//{/*                Add Row*/ }
//{/*            </Button>*/ }

//{/*        </Card.Body>*/ }
//{/*    </Card>*/ }
//{/*</div>*/ }
//const [formRows, setFormRows] = useState([<FormRow key={0} />]);


const StepTwo = ({ handleNext, handleBack, storedData }) => {

    const [workData, setWorkData] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isEdit, setIsEdit] = useState(false);
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = React.useState(null);
    const hideAlert = () => setAlert(null);

    const spanStyle = {
        padding: '8px',
        borderRadius: '5px',
        backgroundColor: '#f2f2f2',
        cursor: 'pointer',
        marginRight: '8px',
    };

    const handleCapitalWord = (event, keyName) => {
        handleEventChange(capitalizeFirstLetter(event.target.value), keyName);
    };

    const [workHistoryData, setWorkHistoryData] = useState({
        JobApplicantsDetailId: 0,
        EmployerName: "",
        LengthOfService: "",
        PositionAndDuties: "",
        ReasonForLeaving: "",
    });

    const resetWorkHistoryData = () => {
        setWorkHistoryData({
            ...workHistoryData,
            JobApplicantsDetailId: 0,
            EmployerName: "",
            LengthOfService: "",
            PositionAndDuties: "",
            ReasonForLeaving: "",
        });
    };

    const handleAdd = () => {
        resetWorkHistoryData();
        handleShow();
        setIsEdit(false);
    };

    const handleEventChange = (event, keyName) => {
        setWorkHistoryData({
            ...workHistoryData,
            [keyName]: event
        });
    };

    const getCharacterCount = (fieldName) => {
        return workHistoryData[fieldName].length;
    };


    function validateForm() {
        return {
            employerNameError: isEmpty(workHistoryData.EmployerName) && 'Employer name is required',
            lengthOfServiceError: isEmpty(workHistoryData.LengthOfService) && 'Length Of Service is required',
            positionDutiesError: isEmpty(workHistoryData.PositionAndDuties) && 'Position & Duties is required',
        };
    }

    const handleEdit = (row) => {
        resetWorkHistoryData();
        const editData = workData.find(data => data.id === row.id); // find the matching GUID
        setWorkHistoryData(editData);
        setIsEdit(true);
        handleShow();
    };

    const deleteAlert = (row) => {
        setAlert(
            <SweetAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => successDelete(row)}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="warning"
                cancelBtnBsStyle="info"
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel>
                You will not be able to recover this data after deletion!
            </SweetAlert>
        );
    };


    const successDelete = (x) => {
        // remove row
        setWorkData((prevData) => prevData.filter((row) => row.guid !== x.guid));
        hideAlert();
    };


    const handleSave = () => {
        const logErrors = validateForm(workHistoryData);

        if (!Object.values(logErrors).some(Boolean)) {
            setErrors([]);

            const newWorkHistory = { ...workHistoryData };

            // creates a GUID for each new item
            if (!newWorkHistory.guid) {
                newWorkHistory.guid = uuidv4();
            }

            const updatedWorkData = [...workData];
            const index = updatedWorkData.findIndex((item) => item.guid === newWorkHistory.guid);

            if (index >= 0) {
                updatedWorkData.splice(index, 1, newWorkHistory);
            } else {
                updatedWorkData.push(newWorkHistory);
            }

            setWorkData(updatedWorkData);
            handleClose();
        } else {
            setErrors(logErrors);
        }
    };

    const handleNextCommand = () => {

        /*      if (workData?.length > 0) {*/
        handleNext(workData);
        /* }*/
        //else {
        //    setAlert(
        //        <SweetAlert
        //            warning
        //            style={{ display: "block", marginTop: "-100px" }}
        //            title="Incomplete Data"
        //            onConfirm={() => hideAlert()}
        //            confirmBtnBsStyle="info"
        //            confirmBtnText="OK">
        //            Please fill out all required fields before proceeding to the next step.
        //        </SweetAlert>
        //    );
        //}
    };

    useEffect(() => {
        // stores the data between the steps
        if (!isEmpty(storedData)) {
            setWorkData(storedData); // set the workData state to storedData
        } else {
            console.log("storedData is empty");
        }
    }, []);



    return (
        <Row>
            {alert}
            <Col sm={12} md={12}>
                <h2 >2. Employment History</h2>
                <p>Start with your most recent job and work back</p>
                <button className="buttonAdd" onClick={() => handleAdd()} >Add New Employment History <i className="fa fa-plus"></i></button>
            </Col>


            <ReusableModal show={show} handleClose={handleClose} handleSubmit={handleSave}
                title={isEdit ? "Update Work History" : "Add Work History"} submitButtonText={isEdit ? "Update" : "Save New"} size="md">
                <Row>
               
                    <Form.Group>
                        <Form.Label>Employer Name</Form.Label>
                        <Form.Control
                            onBlur={(e) => handleCapitalWord(e, "EmployerName")}
                            className={errors.employerNameError ? "form-control is-invalid" : "form-control"}
                            type="text"
                            maxLength="100"
                            value={workHistoryData?.EmployerName}
                            onChange={(e) => handleEventChange(e.target.value, "EmployerName")}
                        ></Form.Control>
                        {errors.employerNameError && <Form.Text className="text-danger"> <span className="star">*</span> {errors.employerNameError} </Form.Text>}
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Length of Service</Form.Label>
                        <Form.Control
                            className={errors.lengthOfServiceError ? "form-control is-invalid" : "form-control"}
                            type="text" maxLength="16"
                            onBlur={(e) => handleCapitalWord(e, "LengthOfService")}
                            value={workHistoryData?.LengthOfService}
                            onChange={(e) => handleEventChange(e.target.value, "LengthOfService")}
                        />
                        {errors.lengthOfServiceError && <Form.Text className="text-danger"> <span className="star">*</span> {errors.lengthOfServiceError} </Form.Text>}
                    </Form.Group>


                    <Form.Group>
                        <Form.Label>Position & Duties</Form.Label>
                        <Form.Control
                            className={errors.employerNameError ? "form-control is-invalid" : "form-control"}
                            as="textarea" rows={4}
                            maxLength="800"
                            style={{
                                height: 'auto',
                            }}
                            onBlur={(e) => handleCapitalWord(e, "PositionAndDuties")}
                            value={workHistoryData?.PositionAndDuties}
                            onChange={(e) => handleEventChange(e.target.value, "PositionAndDuties")}
                        ></Form.Control>
                        {errors.positionDutiesError && <Form.Text className="text-danger"> <span className="star">*</span> {errors.positionDutiesError} </Form.Text>}
                        <CharacterCount count={getCharacterCount("PositionAndDuties")} maxCount="800" />

                    </Form.Group>

                    <Form.Group>
                        <Form.Label>Reason for Leaving</Form.Label>
                        <Form.Control className="form-control" type="text"
                            onBlur={(e) => handleCapitalWord(e, "ReasonForLeaving")}
                            value={workHistoryData?.ReasonForLeaving}
                            maxLength="100"
                            onChange={(e) => handleEventChange(e.target.value, "ReasonForLeaving")}
                        ></Form.Control>
                    </Form.Group>
                </Row>
            </ReusableModal>



            {workData?.length > 0 ? (
                workData.map((item, index) => (
                    <Container key={index} className="my-2">
                        <Row className="justify-content-center align-items-center">
                            <Col md={9}>
                                <Card style={{ border: '1px solid #00384b'}} className="shadow-sm">
                                    <Card.Body>
                                        <Card.Title className="mb-4"> <h6>{item.EmployerName} </h6></Card.Title>
                                        <Row>
                                            <Col md={12}>
                                                <Card.Text className="text-start mb-2">
                                                    <strong>Length of Service:</strong> {item.LengthOfService}
                                                </Card.Text>
                                            </Col>
                                            <Col md={12}>
                                                <Card.Text className="text-start mb-2">
                                                    <strong>Position &amp; Duties:</strong> {item.PositionAndDuties}
                                                </Card.Text>
                                            </Col>
                                            <Col md={12}>
                                                <Card.Text className="text-start mb-2">
                                                    <strong>Reason for Leaving:</strong> {item.ReasonForLeaving}
                                                </Card.Text>
                                            </Col>
                                        </Row>
                                        <div className="d-flex justify-content-end">
                                            <span style={spanStyle} onClick={() => handleEdit(item)}>
                                                <i className="fa fa-edit"></i>
                                                Edit
                                            </span>
                                            <span style={spanStyle} onClick={() => deleteAlert(item)}>
                                                <i className="fa fa-trash"></i>
                                                Delete
                                            </span>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                ))
            ) : (
                <p>No history records have been added yet.</p>
            )}


            <Row>
                <Col sm={12} className="d-flex justify-content-between mt-3">
                    <Button className="btn-lg btn-shadow" variamt="danger" onClick={handleBack} >Back</Button>
                    <Button className="btn-lg btn-shadow" variamt="success" onClick={handleNextCommand} >Next</Button>
                </Col>
            </Row>

        </Row>
    );
};

export default StepTwo;
